export default __webpack_public_path__ + "static/media/gallery-wip-pommel_02.eb28268f.jpg";